import sendGaComponentEvent from "@gcloud-npm/utils.metrics.send-ga-component-event"
export const SCX_PATH = `https://{env}.cms.col.movistar.es/static/js/scx/scx.js`;

var pregTarifActual = 1;
var pregTarifUltima = 1;
var numeroPreguntas = 8;

export function toggleLegalesTarif() {
  document.getElementById("overlay").classList.toggle("active");
}

export function validateTlf() {
  var exprRegTlf = /^[9|8|7|6][0-9]{8}$/;
  var tlfChk = true;
  if (
    document.getElementById("telefonoTarif").value.match(exprRegTlf) != null
  ) {
    document.getElementById("errorTarifTlf").style.display = "none";
  } else {
    document.getElementById("errorTarifTlf").style.display = "block";
    tlfChk = false;
  }

  return tlfChk;
}
export function validateTlf_SE() {
  var exprRegTlf = /^[9|8|7|6][0-9]{8}$/;
  var tlfChk = true;
  if (
    document.getElementById("telefonoTarifSE").value.match(exprRegTlf) != null
  ) {
    document.getElementById("errorTarifTlfSE").style.display = "none";
  } else {
    document.getElementById("errorTarifTlfSE").style.display = "block";
    tlfChk = false;
  }

  return tlfChk;
}

function getCheckedText(option) {
  var auxList = document.getElementsByName(option);
  var result = "";
  for (var i = 0; i < auxList.length; i++) {
    if (auxList[i].checked == true) {
      result = auxList[i].parentElement.children[2].innerText;
      break;
    }
  }
  return result;
}

export function launch_C2C_or_SEform() {
  if (document.getElementById("postalCodeTarif").value.length == 5) {
    let postalCode = document.getElementById("postalCodeTarif").value;

    let codePostalList = [
      "08001",
      "08002",
      "08003",
      "08004",
      "08005",
      "08006",
      "08007",
      "08008",
      "08009",
      "08010",
      "08011",
      "08012",
      "08013",
      "08014",
      "08015",
      "08016",
      "08017",
      "08018",
      "08019",
      "08020",
      "08021",
      "08022",
      "08023",
      "08024",
      "08025",
      "08026",
      "08027",
      "08028",
      "08029",
      "08030",
      "08031",
      "08032",
      "08033",
      "08034",
      "08035",
      "08036",
      "08037",
      "08038",
      "08039",
      "08040",
      "08041",
      "08042",
      "08075",
      "08100",
      "08104",
      "08105",
      "08106",
      "08107",
      "08110",
      "08120",
      "08130",
      "08140",
      "08150",
      "08160",
      "08170",
      "08172",
      "08173",
      "08174",
      "08181",
      "08184",
      "08185",
      "08186",
      "08188",
      "08191",
      "08192",
      "08193",
      "08194",
      "08195",
      "08196",
      "08197",
      "08198",
      "08201",
      "08202",
      "08203",
      "08204",
      "08205",
      "08206",
      "08207",
      "08208",
      "08210",
      "08211",
      "08213",
      "08214",
      "08221",
      "08222",
      "08223",
      "08224",
      "08225",
      "08226",
      "08227",
      "08228",
      "08231",
      "08232",
      "08290",
      "08291",
      "08317",
      "08320",
      "08328",
      "08329",
      "08330",
      "08338",
      "08339",
      "08340",
      "08348",
      "08390",
      "08391",
      "08401",
      "08402",
      "08403",
      "08410",
      "08430",
      "08620",
      "08629",
      "08630",
      "08635",
      "08690",
      "08740",
      "08750",
      "08753",
      "08754",
      "08755",
      "08756",
      "08757",
      "08758",
      "08759",
      "08760",
      "08769",
      "08780",
      "08790",
      "08795",
      "08805",
      "08820",
      "08830",
      "08840",
      "08849",
      "08850",
      "08859",
      "08860",
      "08901",
      "08902",
      "08903",
      "08904",
      "08905",
      "08906",
      "08907",
      "08908",
      "08911",
      "08912",
      "08913",
      "08914",
      "08915",
      "08916",
      "08917",
      "08918",
      "08921",
      "08922",
      "08923",
      "08924",
      "08930",
      "08940",
      "08950",
      "08960",
      "08970",
      "08980",
      "08230",
      "08310",
      "08349",
      "08404",
      "08739",
      "08791",
      "08871",
      "17001",
      "17002",
      "17003",
      "17004",
      "17005",
      "17006",
      "17007",
      "17100",
      "17110",
      "17111",
      "17113",
      "17114",
      "17115",
      "17116",
      "17117",
      "17118",
      "17120",
      "17121",
      "17131",
      "17132",
      "17133",
      "17134",
      "17142",
      "17143",
      "17144",
      "17150",
      "17151",
      "17152",
      "17153",
      "17154",
      "17160",
      "17161",
      "17162",
      "17164",
      "17165",
      "17166",
      "17170",
      "17171",
      "17172",
      "17180",
      "17181",
      "17182",
      "17183",
      "17184",
      "17185",
      "17190",
      "17199",
      "17240",
      "17241",
      "17242",
      "17243",
      "17244",
      "17245",
      "17246",
      "17251",
      "17257",
      "17403",
      "17410",
      "17411",
      "17412",
      "17420",
      "17421",
      "17430",
      "17441",
      "17442",
      "17443",
      "17444",
      "17445",
      "17454",
      "17455",
      "17456",
      "17457",
      "17458",
      "17459",
      "17460",
      "17461",
      "17462",
      "17463",
      "17464",
      "17465",
      "17466",
      "17467",
      "17468",
      "17476",
      "17481",
      "17482",
      "17483",
      "17747",
      "17773",
      "17820",
      "17830",
      "17831",
      "17832",
      "17833",
      "17834",
      "17840",
      "17843",
      "17844",
      "17845",
      "17846",
      "17852",
      "11001",
      "11002",
      "11003",
      "11004",
      "11005",
      "11006",
      "11007",
      "11008",
      "11009",
      "11010",
      "11011",
      "11012",
      "11100",
      "11110",
      "11120",
      "11130",
      "11138",
      "11139",
      "11149",
      "11170",
      "11400",
      "11401",
      "11402",
      "11403",
      "11404",
      "11405",
      "11406",
      "11407",
      "11408",
      "11500",
      "11510",
      "11518",
      "11519",
      "11520",
      "11530",
      "11540",
      "11550",
      "11595",
      "11140",
      "11150",
      "11158",
      "41015",
      "41200",
      "41209",
      "41210",
      "41218",
      "41219",
      "41220",
      "41230",
      "41240",
      "41300",
      "41309",
      "41310",
      "41318",
      "41319",
      "41320",
      "41330",
      "41340",
      "41350",
      "41359",
      "41360",
      "41370",
      "41410",
      "41800",
      "41804",
      "41860",
      "41870",
      "41880",
      "41888",
      "41889",
      "41890",
      "41899",
      "41907",
      "41909",
      "41970",
      "41980",
      "41989",
      "03191",
      "03300",
      "03310",
      "03311",
      "03312",
      "03313",
      "03315",
      "03316",
      "03317",
      "03321",
      "03322",
      "03325",
      "03348",
      "03370",
      "03380",
      "30001",
      "30002",
      "30003",
      "30004",
      "30005",
      "30006",
      "30007",
      "30008",
      "30009",
      "30010",
      "30011",
      "30012",
      "30107",
      "30108",
      "30109",
      "30110",
      "30120",
      "30130",
      "30139",
      "30140",
      "30148",
      "30149",
      "30150",
      "30151",
      "30152",
      "30153",
      "30154",
      "30155",
      "30156",
      "30157",
      "30158",
      "30160",
      "30161",
      "30162",
      "30163",
      "30164",
      "30165",
      "30166",
      "30167",
      "30168",
      "30169",
      "30178",
      "30179",
      "30190",
      "30191",
      "30192",
      "30193",
      "30320",
      "30332",
      "30333",
      "30500",
      "30506",
      "30507",
      "30508",
      "30509",
      "30560",
      "30561",
      "30562",
      "30563",
      "30564",
      "30565",
      "30566",
      "30570",
      "30579",
      "30580",
      "30588",
      "30589",
      "30590",
      "30591",
      "30592",
      "30600",
      "30609",
      "30611",
      "30612",
      "30613",
      "30620",
      "30626",
      "30627",
      "30628",
      "30629",
      "30640",
      "30649",
      "30708",
      "30709",
      "30820",
      "30830",
      "30831",
      "30832",
      "30833",
      "30834",
      "30835",
      "30836",
      "30837",
      "30840",
      "30848",
      "30849",
      "30892",
      "10410",
      "10411",
      "10420",
      "10529",
      "10530",
      "10540",
      "10590",
      "10591",
      "10600",
      "10613",
      "10614",
      "10615",
      "10616",
      "10617",
      "10650",
      "10661",
      "10665",
      "10666",
      "10667",
      "10670",
      "10671",
      "10672",
      "10680",
      "10690",
      "10691",
      "10693",
      "10694",
      "10695",
      "10696",
      "10697",
      "10710",
      "10711",
      "10712",
      "10720",
      "10728",
      "10729",
      "10730",
      "10739",
      "10810",
      "10811",
      "10829",
      "21001",
      "21002",
      "21003",
      "21004",
      "21005",
      "21006",
      "21007",
      "21100",
      "21110",
      "21120",
      "21122",
      "21130",
      "21440",
      "21449",
      "21450",
      "21459",
      "21500",
      "21510",
      "21540",
      "21609",
      "21610",
      "21620",
      "21630",
      "21639",
      "21730",
      "21800",
      "21810",
      "21819",
      "21820",
      "21830",
      "21840",
      "04001",
      "04002",
      "04003",
      "04004",
      "04005",
      "04006",
      "04007",
      "04008",
      "04009",
      "04100",
      "04113",
      "04117",
      "04119",
      "04120",
      "04130",
      "04131",
      "04150",
      "04151",
      "04160",
      "04200",
      "04211",
      "04230",
      "04240",
      "04250",
      "04259",
      "04260",
      "04400",
      "04409",
      "04410",
      "04420",
      "04430",
      "04431",
      "04550",
      "04560",
      "04567",
      "04568",
      "04569",
      "04710",
      "04716",
      "04717",
      "04720",
      "04721",
      "04727",
      "04728",
      "04729",
      "04738",
      "04740",
      "04741",
      "04743",
      "04745",
      "04746",
      "04750",
      "06170",
      "06200",
      "06209",
      "06210",
      "06410",
      "06470",
      "06473",
      "06474",
      "06475",
      "06479",
      "06480",
      "06486",
      "06487",
      "06488",
      "06489",
      "06490",
      "06498",
      "06499",
      "06800",
      "06810",
      "06820",
      "06830",
      "06840",
      "06850",
      "06860",
      "06870",
      "06880",
      "06890",
      "06891",
      "06892",
      "06893",
      "06894",
      "10160",
      "10161",
      "10170",
      "23001",
      "23002",
      "23003",
      "23004",
      "23005",
      "23006",
      "23007",
      "23008",
      "23009",
      "23100",
      "23110",
      "23120",
      "23130",
      "23150",
      "23159",
      "23160",
      "23170",
      "23180",
      "23190",
      "23191",
      "23192",
      "23193",
      "23194",
      "23196",
      "23440",
      "23519",
      "23526",
      "23529",
      "23530",
      "23540",
      "23600",
      "23610",
      "23614",
      "23615",
      "23616",
      "23620",
      "23628",
      "23630",
      "23638",
      "23639",
      "23640",
      "23649",
      "23650",
      "23657",
      "23658",
      "23659",
      "23670",
      "23712",
      "23730",
      "23746",
      "23760",
      "03001",
      "03002",
      "03003",
      "03004",
      "03005",
      "03006",
      "03007",
      "03008",
      "03009",
      "03010",
      "03011",
      "03012",
      "03013",
      "03014",
      "03015",
      "03016",
      "03100",
      "03109",
      "03110",
      "03111",
      "03112",
      "03113",
      "03114",
      "03115",
      "03130",
      "03138",
      "03139",
      "03195",
      "03201",
      "03202",
      "03203",
      "03204",
      "03205",
      "03206",
      "03207",
      "03208",
      "03290",
      "03291",
      "03292",
      "03293",
      "03294",
      "03295",
      "03296",
      "03320",
      "03420",
      "03540",
      "03550",
      "03559",
      "03560",
      "03569",
      "03570",
      "03578",
      "03610",
      "03660",
      "03670",
      "03679",
      "03680",
      "03690",
      "03698",
      "03699",
      "08793",
      "08810",
      "08818",
      "08872",
      "10300",
      "10310",
      "10317",
      "10318",
      "10319",
      "10320",
      "10328",
      "10329",
      "10332",
      "10333",
      "10334",
      "10335",
      "10340",
      "10350",
      "10359",
      "10360",
      "10370",
      "10390",
      "10391",
      "10392",
      "10393",
      "10394",
      "10400",
      "10414",
      "10430",
      "10450",
      "10460",
      "10470",
      "10490",
      "10491",
      "10492",
      "10493",
      "10520",
      "10521",
      "10528",
      "43001",
      "43002",
      "43003",
      "43004",
      "43005",
      "43006",
      "43007",
      "43008",
      "43070",
      "43071",
      "43080",
      "43200",
      "43201",
      "43202",
      "43203",
      "43204",
      "43205",
      "43206",
      "43100",
      "43110",
      "43120",
      "43130",
      "43140",
      "43141",
      "43142",
      "43143",
      "43144",
      "43150",
      "43151",
      "43152",
      "43153",
      "43154",
      "43155",
      "43178",
      "43300",
      "43310",
      "43311",
      "43312",
      "43320",
      "43321",
      "43330",
      "43340",
      "43350",
      "43360",
      "43361",
      "43362",
      "43363",
      "43364",
      "43365",
      "43370",
      "43371",
      "43372",
      "43373",
      "43374",
      "43375",
      "43376",
      "43379",
      "43380",
      "43381",
      "43382",
      "43390",
      "43391",
      "43392",
      "43393",
      "43400",
      "43410",
      "43411",
      "43412",
      "43413",
      "43414",
      "43415",
      "43420",
      "43421",
      "43422",
      "43423",
      "43424",
      "43425",
      "43426",
      "43427",
      "43428",
      "43429",
      "43430",
      "43439",
      "43440",
      "43448",
      "43449",
      "43450",
      "43459",
      "43460",
      "43461",
      "43470",
      "43479",
      "43480",
      "43481",
      "43490",
      "43491",
      "43500",
      "43510",
      "43511",
      "43512",
      "43513",
      "43514",
      "43515",
      "43516",
      "43517",
      "43519",
      "43520",
      "43527",
      "43528",
      "43529",
      "43530",
      "43540",
      "43548",
      "43549",
      "43550",
      "43558",
      "43559",
      "43560",
      "43569",
      "43570",
      "43580",
      "43590",
      "43591",
      "43592",
      "43593",
      "43594",
      "43595",
      "43596",
      "43597",
      "43700",
      "43710",
      "43711",
      "43712",
      "43713",
      "43714",
      "43715",
      "43716",
      "43717",
      "43718",
      "43719",
      "43720",
      "43730",
      "43736",
      "43737",
      "43738",
      "43739",
      "43740",
      "43746",
      "43747",
      "43748",
      "43749",
      "43750",
      "43760",
      "43761",
      "43762",
      "43763",
      "43764",
      "43765",
      "43770",
      "43771",
      "43772",
      "43773",
      "43774",
      "43775",
      "43776",
      "43777",
      "43780",
      "43781",
      "43782",
      "43783",
      "43784",
      "43785",
      "43786",
      "43787",
      "43790",
      "43791",
      "43792",
      "43800",
      "43810",
      "43811",
      "43812",
      "43813",
      "43814",
      "43815",
      "43816",
      "43817",
      "43820",
      "43830",
      "43839",
      "43840",
      "43850",
      "43860",
      "43870",
      "43877",
      "43878",
      "43879",
      "43880",
      "43881",
      "43882",
      "43883",
      "43884",
      "17001",
      "17002",
      "17003",
      "17004",
      "17005",
      "17006",
      "17007",
      "17070",
      "17071",
      "17080",
      "17190",
      "17100",
      "17110",
      "17111",
      "17113",
      "17114",
      "17115",
      "17116",
      "17117",
      "17118",
      "17120",
      "17121",
      "17123",
      "17124",
      "17130",
      "17131",
      "17132",
      "17133",
      "17134",
      "17136",
      "17137",
      "17140",
      "17141",
      "17142",
      "17143",
      "17144",
      "17150",
      "17151",
      "17152",
      "17153",
      "17154",
      "17160",
      "17161",
      "17162",
      "17164",
      "17165",
      "17166",
      "17170",
      "17171",
      "17172",
      "17173",
      "17174",
      "17175",
      "17176",
      "17177",
      "17178",
      "17179",
      "17180",
      "17181",
      "17182",
      "17183",
      "17184",
      "17185",
      "17199",
      "17200",
      "17210",
      "17211",
      "17212",
      "17213",
      "17214",
      "17220",
      "17230",
      "17240",
      "17241",
      "17242",
      "17243",
      "17244",
      "17245",
      "17246",
      "17248",
      "17249",
      "17250",
      "17251",
      "17252",
      "17253",
      "17255",
      "17256",
      "17257",
      "17258",
      "17300",
      "17310",
      "17320",
      "17400",
      "17401",
      "17402",
      "17403",
      "17404",
      "17405",
      "17406",
      "17410",
      "17411",
      "17412",
      "17420",
      "17421",
      "17430",
      "17441",
      "17442",
      "17443",
      "17444",
      "17445",
      "17450",
      "17451",
      "17452",
      "17453",
      "17454",
      "17455",
      "17456",
      "17457",
      "17458",
      "17459",
      "17460",
      "17461",
      "17462",
      "17463",
      "17464",
      "17465",
      "17466",
      "17467",
      "17468",
      "17469",
      "17470",
      "17472",
      "17473",
      "17474",
      "17475",
      "17476",
      "17480",
      "17481",
      "17482",
      "17483",
      "17484",
      "17485",
      "17486",
      "17487",
      "17488",
      "17489",
      "17490",
      "17491",
      "17492",
      "17493",
      "17494",
      "17495",
      "17496",
      "17497",
      "17500",
      "17510",
      "17512",
      "17513",
      "17514",
      "17515",
      "17520",
      "17527",
      "17528",
      "17529",
      "17530",
      "17531",
      "17532",
      "17533",
      "17534",
      "17535",
      "17536",
      "17537",
      "17538",
      "17539",
      "17600",
      "17700",
      "17706",
      "17707",
      "17708",
      "17709",
      "17710",
      "17720",
      "17721",
      "17722",
      "17723",
      "17730",
      "17731",
      "17732",
      "17733",
      "17734",
      "17740",
      "17741",
      "17742",
      "17743",
      "17744",
      "17745",
      "17746",
      "17747",
      "17750",
      "17751",
      "17752",
      "17753",
      "17754",
      "17755",
      "17760",
      "17761",
      "17762",
      "17763",
      "17770",
      "17771",
      "17772",
      "17773",
      "17780",
      "17781",
      "17800",
      "17810",
      "17811",
      "17812",
      "17813",
      "17820",
      "17830",
      "17831",
      "17832",
      "17833",
      "17834",
      "17840",
      "17843",
      "17844",
      "17845",
      "17846",
      "17850",
      "17851",
      "17852",
      "17853",
      "17854",
      "17855",
      "17856",
      "17857",
      "17858",
      "17860",
      "17861",
      "17862",
      "17863",
      "17864",
      "17866",
      "17867",
      "17868",
      "17869",
      "28001",
      "28002",
      "28003",
      "28004",
      "28005",
      "28006",
      "28007",
      "28008",
      "28009",
      "28010",
      "28011",
      "28012",
      "28013",
      "28014",
      "28015",
      "28016",
      "28017",
      "28018",
      "28019",
      "28020",
      "28021",
      "28022",
      "28023",
      "28024",
      "28025",
      "28026",
      "28027",
      "28028",
      "28029",
      "28030",
      "28031",
      "28032",
      "28033",
      "28034",
      "28035",
      "28036",
      "28037",
      "28038",
      "28039",
      "28040",
      "28041",
      "28042",
      "28043",
      "28044",
      "28045",
      "28046",
      "28047",
      "28048",
      "28049",
      "28050",
      "28051",
      "28052",
      "28053",
      "28054",
      "28055",
      "28070",
      "28071",
      "28080",
      "28082",
      "28083",
      "28085",
      "28086",
      "28087",
      "28800",
      "28801",
      "28802",
      "28803",
      "28804",
      "28805",
      "28806",
      "28807",
      "28870",
      "28920",
      "28921",
      "28922",
      "28923",
      "28924",
      "28925",
      "28900",
      "28901",
      "28902",
      "28903",
      "28904",
      "28905",
      "28906",
      "28907",
      "28909",
      "28910",
      "28911",
      "28912",
      "28913",
      "28914",
      "28915",
      "28916",
      "28917",
      "28918",
      "28919",
      "28930",
      "28931",
      "28932",
      "28933",
      "28934",
      "28935",
      "28936",
      "28937",
      "28938",
      "28223",
      "28224",
      "28940",
      "28941",
      "28942",
      "28943",
      "28944",
      "28945",
      "28946",
      "28947",
      "28100",
      "28108",
      "28109",
      "28230",
      "28231",
      "28232",
      "28290",
      "28820",
      "28821",
      "28822",
      "28823",
      "28700",
      "28701",
      "28702",
      "28703",
      "28220",
      "28221",
      "28222",
      "28521",
      "28522",
      "28523",
      "28524",
      "28529",
      "28980",
      "28981",
      "28982",
      "28983",
      "28984",
      "28340",
      "28341",
      "28342",
      "28343",
      "28110",
      "28119",
      "28120",
      "28130",
      "28140",
      "28150",
      "28160",
      "28170",
      "28180",
      "28189",
      "28190",
      "28191",
      "28192",
      "28193",
      "28194",
      "28195",
      "28196",
      "28200",
      "28209",
      "28210",
      "28211",
      "28212",
      "28213",
      "28214",
      "28219",
      "28229",
      "28240",
      "28248",
      "28250",
      "28260",
      "28270",
      "28280",
      "28292",
      "28293",
      "28294",
      "28295",
      "28296",
      "28297",
      "28300",
      "28310",
      "28311",
      "28312",
      "28320",
      "28330",
      "28350",
      "28359",
      "28360",
      "28370",
      "28380",
      "28390",
      "28391",
      "28400",
      "28410",
      "28411",
      "28412",
      "28413",
      "28419",
      "28420",
      "28430",
      "28439",
      "28440",
      "28450",
      "28460",
      "28470",
      "28479",
      "28480",
      "28490",
      "28491",
      "28492",
      "28500",
      "28510",
      "28511",
      "28512",
      "28514",
      "28515",
      "28530",
      "28540",
      "28550",
      "28560",
      "28570",
      "28580",
      "28590",
      "28594",
      "28595",
      "28596",
      "28597",
      "28598",
      "28600",
      "28607",
      "28609",
      "28610",
      "28620",
      "28630",
      "28640",
      "28648",
      "28649",
      "28650",
      "28660",
      "28668",
      "28669",
      "28670",
      "28679",
      "28680",
      "28690",
      "28691",
      "28692",
      "28693",
      "28694",
      "28695",
      "28696",
      "28706",
      "28707",
      "28708",
      "28709",
      "28710",
      "28720",
      "28721",
      "28722",
      "28723",
      "28729",
      "28730",
      "28737",
      "28739",
      "28740",
      "28741",
      "28742",
      "28743",
      "28749",
      "28750",
      "28751",
      "28752",
      "28753",
      "28754",
      "28755",
      "28756",
      "28760",
      "28770",
      "28780",
      "28791",
      "28792",
      "28793",
      "28794",
      "28810",
      "28811",
      "28812",
      "28813",
      "28814",
      "28815",
      "28816",
      "28817",
      "28818",
      "28830",
      "28840",
      "28850",
      "28851",
      "28860",
      "28861",
      "28862",
      "28863",
      "28864",
      "28880",
      "28890",
      "28891",
      "28939",
      "28950",
      "28970",
      "28971",
      "28976",
      "28977",
      "28978",
      "28001",
      "28002",
      "28003",
      "33830",
      "33846",
      "33920",
      "33909",
      "33939",
      "33930",
      "33949",
      "33900",
      "33934",
      "33929",
      "33979",
      "33986",
      "33988",
      "33989",
      "33980",
      "33987",
      "33991",
      "33598",
      "33591",
      "33593",
      "33594",
      "33592",
      "33617",
      "33180",
      "33195",
      "33140",
      "33199",
      "33174",
      "33170",
      "33007",
      "33196",
      "33191",
      "33010",
      "33011",
      "33193",
      "33006",
      "33012",
      "33004",
      "33001",
      "33003",
      "33013",
      "33002",
      "33009",
      "33008",
      "33005",
      "33100",
      "33119",
      "33535",
      "33099",
      "33129",
      "33120",
      "33139",
      "33957",
      "33969",
      "33960",
      "33945",
      "33958",
      "33946",
      "33940",
      "33947",
      "33950",
      "33580",
      "33936",
      "33510",
      "33519",
      "33189",
      "33429",
      "33420",
      "33186",
      "33187",
      "33518",
      "33938",
      "33716",
      "33719",
      "33937",
      "33836",
      "33720",
      "33760",
      "33794",
      "33768",
      "33778",
      "33769",
      "33710",
      "33795",
      "33796",
      "33797",
      "33758",
      "33750",
      "33746",
      "33759",
      "33757",
      "33756",
      "33509",
      "33500",
      "33595",
      "33596",
      "33790",
      "33793",
      "33590",
      "33740",
      "33747",
      "33749",
      "33770",
      "33776",
      "33779",
      "33684",
      "33685",
      "33401",
      "33403",
      "33402",
      "33410",
      "33409",
      "33527",
      "33310",
      "33529",
      "33828",
      "33430",
      "33491",
      "33438",
      "33439",
      "33492",
      "33450",
      "33405",
      "33417",
      "33459",
      "33457",
      "33456",
      "33404",
      "33412",
      "33468",
      "33158",
      "33150",
      "33157",
      "33156",
      "33159",
      "33155",
      "33211",
      "33208",
      "33206",
      "33203",
      "33212",
      "33202",
      "33210",
      "33204",
      "33201",
      "33209",
      "33299",
      "33213",
      "33207",
      "33205",
      "33391",
      "33394",
      "33390",
      "33350",
      "33697",
      "33691",
      "33440",
      "33449",
      "33448",
      "33418",
      "33820",
      "33829",
      "33825",
      "33411",
      "33630",
      "33695",
      "33637",
      "33788",
      "33784",
      "33700",
      "33780",
      "33787",
      "33782",
      "33789",
      "33192",
      "33690",
      "33423",
      "33426",
      "33161",
      "33138",
      "33130",
      "33582",
      "33520",
      "33528",
      "33536",
      "33114",
      "33117",
      "33190",
      "33160",
      "33860",
      "33866",
      "33867",
      "33868",
      "33115",
      "33125",
      "33126",
      "33458",
      "33111",
      "33870",
      "33876",
      "33877",
      "33300",
      "33315",
      "33314",
      "33312",
      "33316",
      "33311",
      "33313",
    ];

    if (codePostalList.includes(postalCode) && offWorkingDay()) {
      document.getElementById("Cotizador-C2C").style.display = "block";
      document.getElementById("Cotizador-SE").style.display = "none";
    } else if (codePostalList.includes(postalCode) && !offWorkingDay()) {
      document.getElementById("Cotizador-C2C").style.display = "none";
      document.getElementById("Cotizador-SE").style.display = "block";
    } else if (!codePostalList.includes(postalCode)) {
      document.getElementById("Cotizador-C2C").style.display = "block";
      document.getElementById("Cotizador-SE").style.display = "none";
    }
  } else {
    document.getElementById("Cotizador-C2C").style.display = "none";
    document.getElementById("Cotizador-SE").style.display = "block";
  }
}
function offWorkingDay() {
  let isWeekend = [0, 6].indexOf(new Date().getDay()) != -1;
  let hoursLocalTime = new Date().getHours();
  let afterHourFriday = hoursLocalTime >= 12 && new Date().getDay() == 5;
  let beforeHourMonday = hoursLocalTime < 9 && new Date().getDay() == 1;
  return isWeekend || afterHourFriday || beforeHourMonday;
}
export function sendTarifSE() {
  if (validateTlf_SE()) {
    //   Formulario
    var ifrm = document.createElement("iframe");
    ifrm.setAttribute("id", "ifrm");
    ifrm.setAttribute("style", "display:none");

    document.body.appendChild(ifrm);
    let postalCode = document.getElementById("postalCodeTarif").value;
    let tlfn = document.getElementById("telefonoTarifSE").value;
    let urlFormulario =
      "https://www.movistar.es/particulares/movistar-prosegur-alarmas/formularioCotizador?postalCode=" +
      postalCode +
      "&tlfn=" +
      tlfn;
    ifrm.setAttribute("src", urlFormulario);
    //   Fin formulario

    // Mensajes de carga, OK y KO
    var msgStep = document.createElement("label");
    msgStep.innerText = "Paso 8 : Contacto";
    var msgLoading = document.createElement("p");
    msgLoading.innerText =
      "Espera unos instantes, estamos procesando tu solicitud.";

    document.getElementById("pregunta-8").innerHTML = "";

    document.getElementById("pregunta-8").append(msgStep);
    document.getElementById("pregunta-8").append(msgLoading);

    window.addEventListener(
      "message",
      (event) => {
        console.log(event);
        if (event.data === "Envio_formulario_OK") {
          console.log("Envio_formulario_OK");
          // Quitar spinner de loading y poner mensaje de OK
          document.getElementById("pregunta-8").innerHTML = "";

          var msgStep = document.createElement("label");
          msgStep.innerText = "Paso 8 : Contacto";

          var msgFormOK = document.createElement("p");
          msgFormOK.innerText =
            "¡Muchas gracias! Tu solicitud se ha enviado con éxito.\nEn breve uno de nuestros asesores se pondrá en contacto contigo.";
          msgFormOK.classList.add("msgFormOK");
          document.getElementById("pregunta-8").append(msgStep);
          document.getElementById("pregunta-8").append(msgFormOK);
        } else if (event.data === "Envio_formulario_KO") {
          // Quitar spinner de loading y poner mensaje de KO !!!
          document.getElementById("pregunta-8").innerHTML = "";

          var msgStep = document.createElement("label");
          msgStep.innerText = "Paso 8 : Contacto";

          var msgFormKO = document.createElement("p");
          msgFormKO.innerText =
            "Ha ocurrido un error, inténtalo de nuevo pasados unos minutos.";
          msgFormKO.classList.add("msgFormKO");
          document.getElementById("pregunta-8").append(msgStep);
          document.getElementById("pregunta-8").append(msgFormKO);
        }

        // Fin Mensajes de carga, OK y KO
      },
      false
    );

    /*window.onmessage = (event) => {
    
  };*/
  } else {
    console.log("Error al introducir el número de telefono en el Cotizador-SE");
  }
}

export function sendTarifC2C() {
  var tlfChk = validateTlf();
  let loadjs = null;
  let env = "prod";
    if (`${process.env.NEXT_PUBLIC_ENV_NAME}` !== env) {
      env = "qa";
    }
    const scxRoute = SCX_PATH.replace("{env}", env);
    import("loadjs").then((module) => {
        loadjs = module.default;
        loadjs(scxRoute, { async: true, returnPromise: true }).then(() => {
            if (tlfChk == true) {
                try {
                    var vivienda = getCheckedText("vivienda");
                    var servicio = getCheckedText("servicio");
                    var ausencias = getCheckedText("ausencias");
                    var superficie = getCheckedText("superficie");
                    var interes1 = "Tipo de casa: " + vivienda + "; Alarma: " + servicio;
                    var interes2 = "Ausencias: " + ausencias + "; Tamano: " + superficie;
                    interes1 = interes1.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    interes2 = interes2.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    window.SCX.setAdditionalInterests(interes1, interes2);
                    window.SCX.processC2C({
                    phone: document.getElementById("telefonoTarif").value,
                    });
                } catch {
                    window.SCX.processC2C({
                    phone: document.getElementById("telefonoTarif").value,
                    });
                }
                try {
                    document.getElementById("plainModal").style.display = "none !important";
                } catch {}
                sendGaComponentEvent({
                    event: "asyncGTM",
                    GAcategory: "Tarificador",
                    GAaction: "confirmacion",
                    GAlabel: "soteira",
                });
            
                document.getElementById("buttonTarif").style.pointerEvents = "none";
                setTimeout(function () {
                    document.getElementById("modalTarif").style.display = "flex";
                }, 500);
            }
        });
    });
}

export function closeModalTarif() {
  try {
    document.getElementById("plainModal").style.display = "none !important";
    document.getElementById("plainModal").classList.remove("show");
  } catch {}
  document.getElementById("modalTarif").style.display = "none";
}

export function clickTarif(element, numero, nameResp) {
  element.classList.add("active");
  for (var i = 0; i < document.getElementsByName(nameResp).length; i++) {
    if (document.getElementsByName(nameResp)[i].parentElement == element) {
      document
        .getElementsByName(nameResp)
        [i].parentElement.children[1].classList.add("icon-check");
    } else {
      document
        .getElementsByName(nameResp)
        [i].parentElement.children[1].classList.remove("icon-check");
      document
        .getElementsByName(nameResp)
        [i].parentElement.classList.remove("active");
    }
  }
  setTimeout(function () {
    if (pregTarifUltima == numero) {
      pregTarifUltima += 1;
      pregTarifActual += 1;
      setPregunta(pregTarifUltima);
    } else {
      pregTarifActual = pregTarifUltima;
      setPregunta(pregTarifUltima);
    }
  }, 100);
}

function setPregunta(numero) {
  if (pregTarifActual != numero) {
    document
      .getElementById("pasos")
      .classList.replace(`paso${numero + 1}`, `paso${numero}`);
    for (var i = numero; i < numeroPreguntas + 1; i++) {
      document.getElementById("pregunta-" + i).style.display = "none";
    }
  }
  for (var i = 1; i < numero; i++) {
    document.getElementById("pregunta-" + i).style.display = "none";
  }
  document.getElementById("pregunta-" + numero).style.display = "block";
  document
    .getElementById("pasos")
    .classList.replace(`paso${numero - 1}`, `paso${numero}`);

  document.querySelectorAll("#pasos span")[numero - 1].classList.add("active");
  if (numero == 8) {
    document.getElementById("backarrow").classList.remove("active");
  } else if (numero > 1) {
    document.getElementById("backarrow").classList.add("active");
  } else if (numero == 1) {
    document.getElementById("backarrow").classList.remove("active");
  }
}

export function preguntaanterior() {
  let preguntaactiva = document.getElementById("pasos").className;
  preguntaactiva = preguntaactiva[preguntaactiva.length - 1];
  preguntaactiva = parseInt(preguntaactiva) - 1;
  pregTarifUltima -= 1;
  setPregunta(preguntaactiva);
}
